import { JsonPipe } from "@angular/common";
import { Component } from "@angular/core";
import { ApiSpecificationModel } from "@app/manual/models/api-models/api-specification-model";
import { ApiSpecComponent } from "../../api-spec";

@Component({
    selector: "app-control-teststeps-score-api-manual",
    templateUrl: "../../api-spec.html",
    styleUrls: ["../../api-spec.scss"],
    standalone: true,
    imports: [JsonPipe]
})
export class ControlTestStepsScoreApiManualComponent extends ApiSpecComponent {
    initSpecs() {
        return <ApiSpecificationModel>{
            name: "Test Steps Score API",
            description: "Used to score a specific Test Step.",

            httpMethod: "POST",
            path: "/controls/testing/advanced/effectiveness/automation/samples/{sampleGuid}/teststeps/{testStepGuid}/score",

            parameters: [
                {
                    name: "sampleGuid",
                    in: "path",
                    paramType: "uuid",
                    required: true,
                    example: "00000000-0000-0000-0000-000000000000",
                },
                {
                    name: "testStepGuid",
                    in: "path",
                    paramType: "uuid",
                    required: true,
                    example: "00000000-0000-0000-0000-000000000000",
                },
                {
                    name: "testStepScore",
                    description: "Score for the Test Step.",
                    in: "query",
                    paramType: "string",
                    required: true,
                    example: "NoScore | Correct | Incorrect | Inapplicable | MissingEvidence",
                },
                {
                    name: "testStepComment",
                    description: "Comment for the Test Step.",
                    in: "query",
                    paramType: "string",
                    required: true,
                },
            ],

            responses: [
                {
                    code: "200",
                    description: "OK",
                    example: "Request has been successfully processed",
                },
            ],
        };
    }
}
